import React, { useEffect, useState } from 'react'
import { Tooltip } from 'antd'
import qs from 'qs'
import { Loading, Empty } from 'meinian-package/src/baseComponent'
import Button from 'meinian-package/src/baseComponent/button'
import Big from 'big.js'
import { TabTDCell } from 'meinian-package/src/component/tabTD'
import Table from 'component/table'
import Pagination from 'baseComponent/pagination'
import request from 'meinian-package/src/utils/request'
import moment from 'moment'
import { getStringWidth } from 'common/strWidth'
import { targetCategory } from 'common/index'
import ChooseStyleTaskModal from 'meinian-package/src/component/createIdeaMass/chooseStyleTask'
import * as userAuth from 'meinian-package/src/utils/auth'
import TaskConditionModal from './taskConditionModal'
import TaskDetailModal from './taskDetailModal'
import useTaskDetailModalAction from './taskDetailModal/useTaskDetailModalAction'

export default ({ onCheckStyle, info, auth }) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [tab, setTab] = useState('progress')
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [params, setParams] = useState({
    start: 0,
    pageSize: 20,
  })
  const [visibleTaskModal, setVisibleTaskModal] = useState(false)
  const [taskType, setTaskType] = useState('create')
  const [taskConditionVisible, setTaskConditionVisible] = useState(false)
  const [taskDetailVisible, setTaskDetailVisible] = useState(false)

  const [taskItem, setTaskItem] = useState({})
  const { onEditTask, onEndTask, onDeleteTask } = useTaskDetailModalAction()
  useEffect(() => {
    fetchListMission()
  }, [])

  const fetchListMission = async (_params) => {
    setLoading(true)
    const tempParams = {
      ...params,
      ..._params
    }
    const res = await request.post(`/ins/blog/mission/list-mission?start=${tempParams.start}&pageSize=${tempParams.pageSize}`, {
      inspirationId: info.id || query.inspirationId,
      queryType: tab,
      ...tempParams
    })
    setData([...res.resultList])
    setTotalCount(res.resultCount)
    setLoading(false)
  }
  const onTab = (val) => {
    setTab(val)
    setParams((pre) => ({ ...pre, start: 0 }))
    fetchListMission({ queryType: val, start: 0 })
  }
  const onCreateChooseStyleTask = () => {
    setTaskType('create')
    setTaskItem(null)
    setVisibleTaskModal(true)
  }
  const onEdit = (record) => { // 修改
    onEditTask(record, () => {
      setTaskType('edit')
      setTaskItem(record)
      setVisibleTaskModal(true)
    })
  }

  const onEnd = (record) => { // 终止
    onEndTask(record, () => fetchListMission())
  }
  const onOk = () => {
    fetchListMission({ start: 0 })
    setParams(pre => ({ ...pre, start: 0 }))
  }
  const onTaskProgress = (record) => { // 查看任务完成情况
    setTaskItem(record)
    setTaskConditionVisible(true)
  }
  const onTaskDetail = (record) => {
    setTaskItem(record)
    setTaskDetailVisible(true)
  }

  const onDelete = (record) => {
    onDeleteTask(record, () => fetchListMission())
  }

  const newCreateTasButton = () => {
    const _auth = userAuth.isPermissions(auth, ['F17'])
    return _auth ? <Button type="primary" onClick={onCreateChooseStyleTask}>新建任务</Button> : null
  }

  return <div className="mn-choose-task-content">
    <div className="mn-choose-task-header">
      <div className="mn-choose-task-header-title">
        <div style={{ marginRight: '40px' }}>选款任务(Beta)</div>
        <div className="meinian-tab-TD">
          <TabTDCell active={tab === 'progress'} onClick={() => onTab('progress')}>进行中</TabTDCell>
          <TabTDCell active={tab === 'closed'} onClick={() => onTab('closed')}>已结束</TabTDCell>
        </div>
      </div>
      {newCreateTasButton()}
    </div>
    <div className="mn-choose-task-content-content">
      <Loading spinning={loading}>
        {
            data.length ? <Table
              className="mn-choose-task-table"
              data={data}
              sortValue={{ key: null, sort: null }}
              columns={columns({ tab, onCheckStyle, auth, onEdit, onEnd, onTaskProgress, onTaskDetail, onDelete })}
              scroll={{ x: 0, y: document.body.clientHeight - 340 }}
            /> : <Empty
              title={`暂无${tab === 'progress' ? '进行中' : '已结束'}的任务`}
              type="task"
              subTitle={newCreateTasButton()}
            />
          }
      </Loading>
      <Pagination
        pageNo={Math.trunc(params.start / 20) + 1}
        pageSize={params.pageSize}
        total={totalCount}
        onChange={(pageNo) => {
          fetchListMission({ start: (pageNo - 1) * 20 })
          setParams((pre) => ({ ...pre, start: (pageNo - 1) * 20 }))
        }}
      />
    </div>
    {
        visibleTaskModal && <ChooseStyleTaskModal
          type={taskType}
          visible={visibleTaskModal}
          taskItem={taskItem}
          inspirationName={info.name}
          inspirationId={info.id}
          setVisible={setVisibleTaskModal}
          onOk={onOk}
        />
    }
    {taskConditionVisible && <TaskConditionModal taskItem={taskItem} visible={taskConditionVisible} onClose={() => setTaskConditionVisible(false)} />}
    {taskDetailVisible && <TaskDetailModal
      taskItem={taskItem}
      visible={taskDetailVisible}
      onEnd={onEnd}
      onEdit={onEdit}
      onDelete={onDelete}
      auth={auth}
      tab={tab}
      footer
      onClose={() => setTaskDetailVisible(false)}
    />}
  </div>
}

const columns = ({ tab, auth, onCheckStyle, onEdit, onEnd, onTaskProgress, onTaskDetail, onDelete }) => {
  return [
    { title: '任务名称',
      dataIndex: 'missionName',
      width: 270,
      key: 'missionName',
      render: (h, record) => {
        const { height, heightLine1 } = getStringWidth(h, 'font-size:14px;width:370px')
        if (height > heightLine1) {
          return <div className="mn-choose-table-missionName">
            <Tooltip title={h}>
              <div className="text-color-1 mn-choose-link mn-choose-table-name">
                <span onClick={() => onTaskDetail(record)}>{h}</span>
              </div>
            </Tooltip>
            {record.missionStatus === 'not_start' && <div className="label">未开始</div>}
          </div>
        }
        return <div className="mn-choose-table-missionName">
          <div className="text-color-1 mn-choose-link mn-choose-table-name">
            <span onClick={() => onTaskDetail(record)}>{h}</span>
          </div>
          {record.missionStatus === 'not_start' && <div className="label">未开始</div>}
        </div>
      } },
    { title: '创建者',
      dataIndex: 'userName',
      width: 260,
      key: 'userName' },
    { title: '任务周期',
      dataIndex: 'taskCycle',
      width: 166,
      key: 'taskCycle',
      render: (h, record) => {
        return <div>
          <div>起&nbsp;{moment(record.startTime).format('YYYY/MM/DD')}</div>
          <div>止&nbsp;{moment(record.endTime).format('YYYY/MM/DD')}</div>
        </div>
      } },
    { title: '任务目标',
      dataIndex: 'missionTargetList',
      width: 230,
      key: 'missionTargetList',
      render: (h) => {
        let str = ''
        h.forEach(item => {
          str += `${targetCategory(item.gender, item.rootCategory, item.category)} ${item.doneNum}/${item.targetNum}<br />`
        })
        const { height, heightLine1 } = getStringWidth(str, 'font-size:14px;width:194px;')
        return <Unfold height={height} heightLine1={heightLine1} h={str} key={h} />
      } },
    { title: '完成情况',
      dataIndex: 'totalDonePercent',
      width: 156,
      key: 'totalDonePercent',
      render: (h, record) => {
        const x = new Big(h).times(100).toFixed()
        return <div>
          <div>完成{x}%</div>
          <div className="mn-choose-link" onClick={() => onTaskProgress(record)}>查看成员完成情况</div>
        </div>
      } },
    {
      title: '操作',
      dataIndex: 'options',
      width: 260,
      key: 'options',
      fixed: 'right',
      render: (h, record) => {
        const checkStyle = userAuth.isPermissions(auth, ['F16'])
        && <div className="mn-choose-link" onClick={() => onCheckStyle(record)}>查看款式</div>
        const termination = userAuth.isPermissions(auth, ['F18']) && <>
          <div className="mn-choose-link" onClick={() => onEnd(record)}>终止</div>
          <div className="mn-choose-options-column-line" />
        </>
        const modify = userAuth.isPermissions(auth, ['F19']) && <>
          <div className="mn-choose-link" onClick={() => onEdit(record)}>修改</div>
          <div className="mn-choose-options-column-line" />
        </>
        const deleteDom = userAuth.isPermissions(auth, ['F20'])
        && <>
          <div className="mn-choose-options-column-line" />
          <div className="mn-choose-link" onClick={() => onDelete(record)}>删除</div>
        </>
        return <div className="mn-choose-options-column">
          {
              tab === 'closed' ? <>
                {checkStyle}
                {deleteDom}
              </> : <>
                {termination}
                {modify}
                {checkStyle}
                {deleteDom}
              </>
            }
        </div>
      }
    }
  ]
}

const Unfold = ({ height, heightLine1, h }) => {
  const [show, setShow] = useState(false)
  return <div className="mn-choose-table-unfold">
    <div className="mn-choose-table-unfold-str" style={{ overflow: 'hidden', height: !show ? heightLine1 * 2 : height }} dangerouslySetInnerHTML={{ __html: h }} />
    {height > heightLine1 * 2 && <div className="unfold-btn" onClick={() => setShow(!show)}>{show ? '收起' : '展开'}</div>}
  </div>
}
